import React, {Component, Fragment} from 'react';
import {withRouter} from 'react-router-dom';

import MetisMenu from 'react-metismenu';

import {MainNav, DemograficoNav, SatisfaccionNav, ObjetivosJuegoNav, ExtraDELETE,SponsorNav} from './NavItems';
import Sponsors from '../../Pages/Sponsor';
import privateActions from '../../API/privateCalls/privateActions';

class Nav extends Component {

    state = {listaMenu:[],loading:true};
  componentDidMount(){
    privateActions.getMenu().then(res=>{
        this.setState({loading:false,listaMenu:res})
    })
  }
    render() {
      if(this.state.loading)return null
        return (
            <Fragment>
            {  this.state.listaMenu.map(e=>{ 
              console.warn(e.options)
         
            return(
              <div>
               <h5 className="app-sidebar__heading">{e.category}</h5>
               <MetisMenu content={e.options} activeLinkFromLocation className="vertical-nav-menu" iconNamePrefix="" classNameStateIcon="pe-7s-angle-down"/>
               </div>
            )})}
              </Fragment>
        );
    }

    isPathActive(path) {
        return this.props.location.pathname.startsWith(path);
    }
}

export default withRouter(Nav);


// WEBPACK FOOTER //
// src/Layout/AppNav/VerticalNavWrapper.js